<template>
  <svg
    v-if="less_is_better"
    :width="size"
    :height="size"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 22"
    fill="none"
  >
    <path
      d="M0.457031 15.5791C4.04004 14.0594 12.3395 12.8335 19.0928 19.3242V16.999C19.0929 16.5849 19.4287 16.249 19.8428 16.249C20.2567 16.2492 20.5926 16.5851 20.5928 16.999V21.2051C20.5928 21.6192 20.2568 21.9549 19.8428 21.9551H15C14.5858 21.9551 14.25 21.6193 14.25 21.2051C14.2503 20.7911 14.586 20.4551 15 20.4551H18.1025C11.901 14.4583 4.28933 15.5832 1.04297 16.96C0.661644 17.1217 0.221325 16.9438 0.0595703 16.5625C-0.101943 16.1813 0.0758165 15.7408 0.457031 15.5791ZM0.457031 12.9766C4.11679 11.4243 10.3042 11.2625 16.6035 14.2793V13.0127C16.6037 12.5987 16.9394 12.2627 17.3535 12.2627C17.7674 12.2629 18.1033 12.5988 18.1035 13.0127V15.5C18.1035 15.7638 17.9646 16.0081 17.7383 16.1436C17.5117 16.2789 17.2304 16.2852 16.998 16.1602C10.671 12.7533 4.44293 12.9154 1.04297 14.3574C0.661699 14.5192 0.221382 14.3412 0.0595703 13.96C-0.102175 13.5787 0.0757543 13.1383 0.457031 12.9766ZM9.11035 0.161133C9.45291 -0.0768301 9.91959 -0.0513253 10.2344 0.233398L18.0166 7.27441C18.6307 7.8306 18.2368 8.85126 17.4082 8.85156H15.2295V10.2607C15.2295 10.6748 14.8935 11.0105 14.4795 11.0107C14.0653 11.0107 13.7295 10.675 13.7295 10.2607V8.25781C13.7296 7.75767 14.1356 7.35156 14.6357 7.35156H15.8662L9.6123 1.69336L2.89648 7.35156H4.32227C4.82227 7.35176 5.22836 7.75779 5.22852 8.25781V10.2607C5.22852 10.6748 4.89255 11.0105 4.47852 11.0107C4.0643 11.0107 3.72852 10.675 3.72852 10.2607V8.85156H1.26855C0.423794 8.85148 0.0394363 7.79719 0.685547 7.25293L9.04297 0.211914L9.11035 0.161133Z"
      :fill="iconColor"
    />
  </svg>
  <svg
    v-else
    :width="size"
    :height="size"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18.498 18.5605C18.7304 18.4357 19.0118 18.4419 19.2383 18.5771C19.4646 18.7124 19.6033 18.9571 19.6035 19.2207V21.6328C19.6034 22.0468 19.2675 22.3826 18.8535 22.3828C18.4394 22.3828 18.1037 22.0469 18.1035 21.6328V20.4414C11.7982 23.4537 5.611 23.2188 1.95703 21.6689C1.57577 21.5072 1.39783 21.0668 1.55957 20.6855C1.72144 20.3044 2.16175 20.1264 2.54297 20.2881C5.94923 21.7328 12.1777 21.9638 18.498 18.5605ZM21.3428 12.6904C21.7568 12.6906 22.0928 13.0263 22.0928 13.4404V17.501C22.0925 17.9149 21.7567 18.2508 21.3428 18.251C20.9287 18.251 20.593 17.915 20.5928 17.501V15.3213C13.8395 21.8119 5.54005 20.5861 1.95703 19.0664C1.57586 18.9047 1.39815 18.4642 1.55957 18.083C1.72132 17.7017 2.16164 17.5238 2.54297 17.6855C5.78935 19.0623 13.401 20.1872 19.6025 14.1904H17C16.586 14.1904 16.2504 13.8543 16.25 13.4404C16.25 13.0262 16.5858 12.6904 17 12.6904H21.3428ZM10.6104 1.16211C10.9529 0.924151 11.4196 0.949653 11.7344 1.23438L19.5166 8.27539C20.1307 8.83157 19.7368 9.85225 18.9082 9.85254H16.7295V11.2617C16.7295 11.6758 16.3935 12.0115 15.9795 12.0117C15.5653 12.0117 15.2295 11.6759 15.2295 11.2617V9.25879C15.2297 8.75866 15.6356 8.35254 16.1357 8.35254H17.3662L11.1123 2.69434L4.39648 8.35254H5.82227C6.32227 8.35273 6.72834 8.75878 6.72852 9.25879V17C6.72852 17.4141 6.39256 17.7498 5.97852 17.75C5.5643 17.75 5.22852 17.4142 5.22852 17V9.85254H2.76855C1.92379 9.85246 1.53944 8.79817 2.18555 8.25391L10.543 1.21289L10.6104 1.16211Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  less_is_better: {
    type: Boolean,
    default: false,
  },
  size: {
    type: Number,
    default: 24,
    validator: (value) => [24, 16].includes(value),
  },
  color: {
    type: String,
    default: "Grey",
    validator: (value) => ["Grey", "White"].includes(value),
  },
});

const iconColor = computed(() => {
  return props.color === "Grey" ? "#666666" : "white";
});
</script>

<style scoped>
svg {
  display: block;
}
</style>
